import React from 'react';
import { Row, Col } from 'react-bootstrap';
import PropTypes from 'prop-types';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
// eslint-disable-next-line css-modules/no-unused-class
import s from './EnvMetrics.scss';

const SENSORS = [
  {
    entityId: [
      'switchbot_meter_pro_1_kohlendioxid',
      'meter_pro_co2_0b6c_carbon_dioxide',
      'switchbot_meter_pro_3_carbon_dioxide',
    ],
    displayName: 'CO₂',
    unit: 'ppm',
  },
  {
    entityId: [
      'switchbot_meter_pro_1_luftfeuchtigkeit',
      'meter_pro_co2_0b6c_humidity',
      'switchbot_meter_pro_3_humidity',
    ],
    displayName: 'Humidity',
    unit: '%',
  },
  {
    entityId: [
      'switchbot_meter_pro_1_temperatur',
      'meter_pro_co2_0b6c_temperature',
      'switchbot_meter_pro_3_temperature',
    ],
    displayName: 'Temperature',
    unit: '°C',
  },
];

class LiveEnvMetrics extends React.Component {
  static propTypes = {
    title: PropTypes.string.isRequired,
    loading: PropTypes.bool.isRequired,
    data: PropTypes.arrayOf(
      PropTypes.shape({
        entityId: PropTypes.string.isRequired,
        value: PropTypes.number.isRequired,
      }),
    ),
  };

  static defaultProps = {
    data: [],
  };

  getMetrics() {
    const { data } = this.props;

    const dataMap = data.reduce((acc, item) => {
      acc[item.entityId] = item.value;
      return acc;
    }, {});

    return SENSORS.map(sensor => {
      // find the first entityId that exists in dataMap
      const rawValue = sensor.entityId
        .map(id => dataMap[id])
        .find(v => typeof v === 'number');

      return {
        ...sensor,
        value: typeof rawValue === 'number' ? rawValue.toFixed(2) : '0.00',
      };
    });
  }

  render() {
    const { loading } = this.props;

    if (loading) {
      return null;
    }

    const metrics = this.getMetrics();

    return (
      <div className={s.card}>
        <div className={s.cardTitle}>{this.props.title}</div>
        <div className={s.cardItemsWrapper}>
          {metrics.map(item => (
            <Row className={s.cardItem} key={item.displayName}>
              <Col md={6} className={s.displayName}>
                {item.displayName}
              </Col>
              <Col md={6} className={s.alignRight}>
                {item.value}&nbsp;
                <span style={{ fontWeight: 600 }}>{item.unit}</span>
              </Col>
            </Row>
          ))}
        </div>
      </div>
    );
  }
}

export default withStyles(s)(LiveEnvMetrics);
